import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledCategoryCard = styled.div<{
  isCategorySelected: boolean
}>`
  background: ${({ isCategorySelected }) =>
    isCategorySelected ? theme.token.var('colors.green.a150') : theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.big')};
  padding: 14px 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    padding: 25px 20px;
  }
`

export const Image = styled.img`
  width: 120px;
`

export const StyledName = styled.p<{ isCategorySelected: boolean }>`
  font-size: ${theme.token.var('fontSizes.xs')};
  font-weight: 500;
  text-align: center;
  // margin-top: 17px;
  hyphens: auto;
  color: ${({ isCategorySelected }) =>
    isCategorySelected ? theme.token.var('colors.white') : theme.token.var('colors.black')};

  @media (min-width: ${theme.token('breakpoints.md')}) {
    font-size: ${theme.token.var('fontSizes.lg')};
    // margin-top: 35px;
  }
`
